import { render } from "./Medicare.vue?vue&type=template&id=7a734cce&ts=true"
import script from "./Medicare.ts?vue&type=script&lang=ts&external"
export * from "./Medicare.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__